module.exports = __webpack_public_path__ + "img/subscription.0af9f49e.svg";